/* global $ */

import icon from '../../helpers/icon';

/**
 * Render a single list item DOM node
 * @return {Node}            Native DOM node
 * @param text
 * @param input
 */
export default (text, input) => {
  const columns = [];
  const label = text.replace(RegExp(input.trim(), 'gi'), '<strong>$&</strong>');

  if (text.value.image) {
    columns.push(`
      <div class="col-3 pr-0">
        <img src="${text.value.image}" class="img-fluid" alt="">
      </div>
    `);
  }

  columns.push(`
    <div class="${text.value.image ? 'col-9' : 'col-12'}">
      ${label}
    </div>
  `);

  return $(`
    <li class="awesomplete__item" aria-selected="false">
      <div class="row align-items-center">
        ${columns.join('')}
      </div>
      ${icon('arrow-right')}
    </li>
  `)[0];
};
